import { useEffect, useState } from 'react';

import Check from '../../assets/icons/check.png';
import DoubleCheck from '../../assets/icons/doublecheck.png';

import Button from '../../../../../../components/bases/button/button';




export default function ReplaceForm({
  lang,
  showReplace,
  onReplaceOne,
  onReplaceAll,
  onReplaceClose,
}) {
  const [text, setText] = useState('');

  useEffect(() => {
    if (!showReplace) {
      setText('');
    }
  }, [showReplace]);

  function onKeyDown(event) {
    event.preventDefault();
    event.stopPropagation();

    if (event.key === 'Tab') {
      if (event.shiftKey) {
        document.querySelector('#btnActivateReplace').focus();
        return;
      }

      document.querySelector('#btnReplace').focus();
      return;
    }

    const input = event.target;

    if (!event.ctrlKey) {
      var char = event.key;
      if (char.length === 1) {
        var code = char.codePointAt(0);

        if (code >= 32) {
          let start = input.selectionStart;
          let end = input.selectionEnd;
          setText(text.substring(0, start) + event.key + text.substring(end));
          setCursorPosition(input, start + 1);
        }

        return;
      }

      if (event.key === 'Backspace') {
        onBackspace(input);
        return;
      }

      if (event.key === 'Delete') {
        onDelete(input);
        return;
      }

      if (event.key === 'ArrowLeft') {
        if (input.selectionStart === 0) return;

        setCursorPosition(input, input.selectionStart - 1);
        return;
      }

      if (event.key === 'ArrowRight') {
        if (input.selectionStart === text.length) return;

        setCursorPosition(input, input.selectionStart + 1);
        return;
      }

      if (event.key === 'Home') {
        setCursorPosition(input, 0);
        return;
      }

      if (event.key === 'End') {
        setCursorPosition(input, text.length);
        return;
      }
    } else {
      if (event.key === 'v') {
        const navigator = event.nativeEvent.view.navigator;
        onPaste(navigator, input);
        return;
      }

      if (event.key === 'a') {
        input.setSelectionRange(0, text.length);
        return;
      }

      if (event.key === 'ArrowLeft') {
        let start = input.selectionStart;
        let end = input.selectionEnd;

        if (start === 0) return;

        input.setSelectionRange(start - 1, end);
        return;
      }

      if (event.key === 'ArrowRight') {
        let start = input.selectionStart;
        let end = input.selectionEnd;

        if (end === text.length) return;

        input.setSelectionRange(start, end + 1);
        return;
      }

      if (event.key === 'f' || event.key === 'h') {
        onReplaceClose();
        return;
      }
    }
  }

  async function onPaste(navigator, input) {
    const permission = await navigator.permissions.query({
      name: 'clipboard-read',
    });

    if (permission.state === 'granted' || permission.state === 'prompt') {
      navigator.clipboard.readText().then((clipText) => {
        let start = input.selectionStart;
        let end = input.selectionEnd;

        setText(text.substring(0, start) + clipText + text.substring(end));
      });
    } else {
      this.setState({
        popup: {
          ...this.state.popup,
          display: true,
          showIcon: true,
          text: {
            fr: "Permission d'accès au presse-papiers refusée.",
            en: 'Permission to access the clipboard denied.',
          },
        },
      });
    }
  }

  function onBackspace(input) {
    let start = input.selectionStart;
    let end = input.selectionEnd;

    let selectedText = input.value.substring(start, end);

    if (selectedText.length === text.length) {
      setText('');
      return;
    }

    setText(text.substring(0, start - 1) + text.substring(end));
    setCursorPosition(input, start - 1);
  }

  function onDelete(input) {
    let start = input.selectionStart;
    let end = input.selectionEnd;

    let selectedText = input.value.substring(start, end);

    if (selectedText.length === text.length) {
      setText('');
      return;
    }

    setText(text.substring(0, start) + text.substring(end + 1));
    setCursorPosition(input, start);
  }

  function setCursorPosition(inputElement, position) {
    setTimeout(() => {
      inputElement.setSelectionRange(position, position);
    }, 0);
  }

  function onChange(event) {
    setText(event.target.value);
  }

  if (!showReplace) {
    return null;
  }

  return (
    <div className="replace-form">
      <label htmlFor="txtReplace" className="sr-only">
        {lang === 'fr' ? 'Remplacer' : 'Replace'}
      </label>
      <input
        id="txtReplace"
        type="text"
        placeholder={lang === 'fr' ? 'Remplacer' : 'Replace'}
        value={text}
        onChange={onChange}
        onKeyDown={onKeyDown}
      />

      <Button
        id="btnReplace"
        tooltip={{
          fr: 'Remplacer',
          en: 'Replace',
        }}
        image={Check}
        width={16}
        height={16}
        onClick={() => onReplaceOne(text)}
      ></Button>
      <Button
        id="btnReplaceAll"
        tooltip={{
          fr: 'Tout remplacer',
          en: 'Replace all',
        }}
        image={DoubleCheck}
        width={16}
        height={16}
        onClick={() => onReplaceAll(text)}
      ></Button>
    </div>
  );
}
